import { DATE_FORMAT } from "helpers/common";
import Badge from "react-bootstrap/Badge";
import React from "react";

const Columns = ({ deleteHandler, handleEdit, permissions }) => [
  {
    dataField: "name",
    text: "Name",
    formatter: (_, row) => (
      <span className="text-capitalize">{row?.name || "--"}</span>
    ),
  },
  {
    dataField: "energy",
    text: "Energy",
    formatter: (_, row) => (
      <span className="">{row?.energy || 0}</span>
    ),
  },
  {
    dataField: "price",
    text: "Price",
    formatter: (_, row) => (
      <span className="">{row?.price || 0}</span>
    ),
  },
  {
    dataField: "discountedPrice",
    text: "Discounted Price",
    formatter: (_, row) => (
      <span className="">{row?.discountedPrice || 0}</span>
    ),
  },
  {
    dataField: "isHotOffer",
    text: "Hot Offer",
    formatter: (_, row) => (
      <span className="text-capitalize">{row?.isHotOffer? "Yes": "No"}</span>
    ),
  },

  {
    text: "Status",
    dataField: "status",
    formatter: (cellContent, row) => (
      <Badge
        className={
          `text-capitalize font-size-13 badge-soft-${row.status}`
        }
        color={row.badgeClass}
      >
        {row.status}
      </Badge>
    ),
  },
  {
    text: "Created At",
    dataField: "date_created_utc",
    formatter: (_, row) => row.date_created_utc && DATE_FORMAT(row.date_created_utc),
  },
  {
    text: "Action",
    // dataField: "Inactive",
    formatter: (_, row) => (
      <>
        {permissions?.edit ?
          <button
            className="fas fa-pen"
            title="Edit"
            style={{
              backgroundColor: "#fff",
              border: "none",
            }}
            onClick={() => handleEdit(row)}
          ></button>
          : null}
        {permissions?.delete ?
          <button
            className="fas fa-trash-alt"
            style={{
              backgroundColor: "#fff",
              border: "none",
            }}
            title="Remove"
            onClick={() => deleteHandler(row._id)}
          ></button>
          : null}

      </>
    ),
  },
];
export default Columns;